var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":_vm.title,"center":"","custom-class":"agreement-form","visible":_vm.agreementStatus,"before-close":_vm.beforeClose},on:{"update:visible":function($event){_vm.agreementStatus=$event}}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.htmlText)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }